import { skipToken, useQuery } from '@tanstack/react-query';

import { Assets } from '@air/api';

import { getAssetCustomFieldsKey } from '~/constants/react-query-keys';

type ListAssetCustomFieldsParams = NonNullable<Parameters<typeof Assets.listCustomFields>[0]>;

export type UsePrivateAssetCustomFieldsDataParams = {
  assetId: ListAssetCustomFieldsParams['assetId'] | undefined;
  workspaceId: ListAssetCustomFieldsParams['workspaceId'] | undefined;
};

export type UsePrivateAssetCustomFieldsDataOptions = {
  canViewCustomFields: boolean;
};

export const usePrivateAssetCustomFieldsData = (
  { assetId, workspaceId }: UsePrivateAssetCustomFieldsDataParams,
  { canViewCustomFields }: UsePrivateAssetCustomFieldsDataOptions,
) => {
  const params = workspaceId && assetId ? { assetId, options: { limit: 100 }, workspaceId } : undefined;

  return useQuery({
    queryKey: getAssetCustomFieldsKey(assetId),
    queryFn: params ? () => Assets.listCustomFields(params) : skipToken,
    enabled: !!params && canViewCustomFields,
    select: (customFields) => (canViewCustomFields ? customFields : undefined),
  });
};
